import type { CheckboxProps } from "@mui/material";
import { get } from "lodash-es";
import {
  type Control,
  Controller,
  type FieldError,
  type FieldErrors,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";

import { BlCheckboxInput } from "Shared/Inputs/BlCheckboxInput";

export type BlFormCheckboxProps<FormType extends FieldValues> = Omit<
  CheckboxProps,
  "onChange"
> & {
  name: FieldPath<FormType>;
  label?: string | React.JSX.Element;
  labelEndAdornment?: React.ReactNode;
  control: Control<FormType>;
  errors: FieldErrors<FormType>;
  isLabelFirst?: boolean;
  onChange?: (value: boolean) => void;
  shouldUnregister?: boolean;
};

export const BlFormCheckbox = <T extends FieldValues>({
  control,
  errors,
  name,
  isLabelFirst,
  onChange: externalOnChange,
  shouldUnregister,
  ...rest
}: BlFormCheckboxProps<T>): React.ReactNode => {
  return (
    <Controller
      control={control}
      name={name}
      shouldUnregister={shouldUnregister}
      render={({ field: { onChange: controllerOnChange, value, ref } }) => (
        <BlCheckboxInput
          slotProps={{ input: { ref } }}
          onChange={(e) => {
            controllerOnChange(e.target.checked);
            externalOnChange?.(e.target.checked);
          }}
          value={value}
          checked={value === true}
          name={name}
          isLabelFirst={isLabelFirst}
          fieldError={get(errors, name as string) as FieldError | undefined}
          {...rest}
        />
      )}
    />
  );
};
